import styled from "styled-components";

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  min-height: 100vh;
  max-width: 1080px;
  padding: 1rem;
`;

export const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 2rem;
`;

export const LastNewsMessage = styled.p`
  color: ${(props) => props.theme["gray-100"]};
  font-weight: 500;
  margin-top: -24px;
  margin-bottom: 24px;
`;

export const NoticiaNotFound = styled.p`
  position: absolute;
  color: ${(props) => props.theme["gray-100"]};
  text-align: center;
  font-weight: 400;
  font-size: 1.75rem;
  max-width: 720px;
  width: 90%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const DeleteButton = styled.button`
  background-color: #ff0000;
  color: #ffffff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
`;
